export default {"src":"/_next/static/media/PPL.2d57a8a2.svg","height":18,"width":18};